import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { useUnit } from 'hooks/units/index';
import useI18n from 'hooks/use-i18n';
import { useUser } from 'hooks/index';
import {
  CONFERENCE_TYPE,
  UNIT_TYPE,
  USER_EVENT_TYPE,
} from 'constants/constants';

import sessionUserApi from 'api/sessionUserApi';
import userEventApi from 'api/userEventApi';
import unitCourseApi from 'api/unitCourseApi';
import { handleToastError } from 'helpers/index';
import { fetchUnitAsync } from 'store/units/index';
import { openAccessCode } from 'store/modal/index';
import ModalRecorded from 'components/Modal/ModalRecorded/ModalRecorded';
import ModalInputAccessCode from 'components/Modal/ModalInputAccessCode';
import EventItem from './EventItem';
import { useSettingConferences } from '../../../../../hooks/settings';
import ModalZoom from './modalZoomLink';
import unitsApi from 'api/unitsApi';
import { showToastSuccess } from '@core/components/toastify/ToastTypes';

const ContentCalendar = () => {
  const i18n = useI18n();
  const dispatch = useDispatch();
  const router = useRouter();
  const [isLoading, setLoading] = useState(false);
  const [waittime, setWaittime] = useState('Join Room');
  const [zoomLink, setZoomLink] = useState();
  const [openZoom, setOpenZoom] = useState(false);
  const unitSelected = useUnit();
  const userLoggedIn = useUser();
  const conferenceType = useSettingConferences();
  const { query } = router;

  const updateAttendance = async () => {
    try {
      let params = {
        id: query?.unitId,
      };
      const response = await unitCourseApi.getUnit(params);
      response?.events[0]?._id &&
        (await unitsApi.liveclassupdateattendance(response?.events[0]?._id));
    } catch (e) {
      console.log(e);
    }
  };

  const handleRegister = async (eventId) => {
    try {
      setLoading(true);

      const data = {
        session: eventId,
        unit: unitSelected?._id,
        user: userLoggedIn._id,
      };

      await sessionUserApi.create(data);

      dispatch(fetchUnitAsync(unitSelected?._id));
      showToastSuccess('User registered successfully');
      setLoading(false);
    } catch (e) {
      handleToastError(e, i18n);
      setLoading(false);
    }
  };

  const onToggle = async () => {
    setOpenZoom(!openZoom);
  };

  const handleUnregister = async (sectionUserId) => {
    try {
      setLoading(true);

      await sessionUserApi.delete(sectionUserId);
      dispatch(fetchUnitAsync(unitSelected?._id));
      showToastSuccess('User unregistered successfully');
      setLoading(false);
    } catch (e) {
      handleToastError(e, i18n);
      setLoading(false);
    }
  };

  const handleJoinRoom = async (eventId, accessCodeRequired) => {
    if (accessCodeRequired) {
      return dispatch(openAccessCode(eventId));
    }

    try {
      if (conferenceType === CONFERENCE_TYPE.ZOOM) {
        const payload = await userEventApi.getLink(eventId);
        //showToastSuccess("Wait for some time for zoom app to open. Don’t click the 'Join Room' until the zoom app is opened");
        if (payload.data) {
          setZoomLink(payload.data);
          setOpenZoom(true);
        }
      } else {
        const link = await userEventApi.getLinkBBB(eventId);
        if (link) {
          setZoomLink(link);
          setOpenZoom(true);
        }
      }
      setLoading(false);
    } catch (e) {
      dispatch(fetchUnitAsync(unitSelected?._id));
      handleToastError(e, i18n, undefined, true);
      setLoading(false);
    }
  };

  const handleAttendance = (eventId) => {
    updateAttendance();
    router.push(
      `/course/${query?.slug}/${
        unitSelected.type === USER_EVENT_TYPE.CLASSROOM
          ? 'add-classroom'
          : 'add-live-training'
      }/${query?.unitId}/users?session=${eventId}`,
    );
  };

  return (
    <div>
      <ModalRecorded />
      <ModalInputAccessCode />
      <h3 className="text-center card-header-title-label">
        {unitSelected?.events?.length > 0 ? (
          <>
            This is a{' '}
            {unitSelected.type === UNIT_TYPE.CLASSROOM
              ? 'class room'
              : 'live training'}{' '}
            event.{' '}
            {unitSelected?.events?.[0]?.registered &&
              'Below is the session to attend.'}
          </>
        ) : (
          <>There are no available sessions at this moment.</>
        )}
      </h3>
      {unitSelected?.events?.map((event) => (
        <EventItem
          key={event._id}
          event={event}
          isLoading={isLoading}
          onRegister={handleRegister}
          onUnregister={handleUnregister}
          onJoinRoom={handleJoinRoom}
          onAttendance={handleAttendance}
          waittime={waittime}
        />
      ))}
      <ModalZoom open={openZoom} toggle={onToggle} link={zoomLink} />
    </div>
  );
};

export default ContentCalendar;
